import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,
  
  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    nombres:'',
    telefonos:'',
    direccions:'',
    correos :'',
    usuarios:'',
    transportistas:[],
    transportista:[]
    
  },
  mutations: {

    LoadProductos(state,buscar) {
      //let aux = [];
      state.transportista = state.transportistas;

      let aux = state.transportistas.filter((x) => x["nombretransportista"].toUpperCase().includes(buscar.toUpperCase()),);
      if (buscar == "") {
        state.transportista = state.transportistas;
      } else {
        state.transportista = aux;
     
      }
    },

    
    async  cargardatostransportistas (state){
      
      state.transportistas = []
      var token = store.state.numero;
      await axios
      .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Transportista", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        state.transportistas = response.data.data;
     
      });
      state.transportista = state.transportistas
    },



    
    cambio(state,descripcion){
      state.nombres = descripcion.nombre,
      state.telefonos= descripcion.telefono,
      state.direccions = descripcion.direccion,
      state.correos = descripcion.correo
      
    },
    agregartable(state)  {
      
      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        nombretransportista: state.nombres,
        telefonotransportista: state.telefonos,
        direcciontransportista: state.direccions,
        emailtransportista:state.correos

      };
      this.banderamodal = store.state.banderamodal
      
      
      
      var datosfalso = state.idmodal;
    
      if (this.banderamodal === true) {
        
        
        axios
        
        .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Transportista", datos, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          this.token = tokenn;
        
          
        })
        
        .catch((e) => {
          console.log(e);
        });
      } else {
        
        axios
        
        .post(
          "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Transportista/UpdateReg/" +
          datosfalso,
          datos,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;
        
          })
          
          .catch((e) => {
            console.log(e);
          });
        }
        
      },
      
      
      datosmodal(state, api) {
      
        state.idmodal =api.idtransportista
       state.nombres= api.nombretransportista
       state.telefonos = api.telefonotransportista
       state.correos= api.emailtransportista
       state.direccions= api.direcciontransportista
       
        
      },
      
      
      
      eliminar(state, api) {
        var token = store.state.numero
        let eliminar = api;
    
        axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Transportista/DeleteReg/" + eliminar,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        
        
        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          state.eliminer = tokenn;
        
          //this.bandera = true;
        })
        
        .catch((e) => {
          console.log(e);
        });
        
        
        
      },
      
      
      
    },
    actions: {
      
    },
    getters: {
      
      
    },
    
    
    



}